import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { MyProSidebarProvider } from "../pages/global/sidebar/sidebarContext";
import Loader from "../components/Loader";
import Topbar from "../pages/global/Topbar";

import { userRoutes } from "../routes";
import { isLoggedIn } from "../utils";

function UserLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated, loading } = useSelector(
    ({ user: { token }, loading }) => ({
      isAuthenticated: isLoggedIn(token),
      loading,
    })
  );

  useEffect(() => {
    if (location.pathname === "/user") {
      if (isAuthenticated) {
        navigate("/user/profile");
      } else {
        navigate("/user/login");
      }
    }
  }, [navigate, location.pathname, isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/user/login" />;
  }

  return (
    <>
      <Loader visible={loading} />
      <MyProSidebarProvider>
        <div style={{ height: "100%", width: "100%" }}>
          <main>
            <Topbar />
            <Routes>
              {userRoutes.map((route, key) => (
                <Route 
                  key={key} 
                  path={route.path} 
                  element={route.component} 
                />
              ))}
              {/* Redirect /user to /user/profile if authenticated */}
              <Route path="/" element={<Navigate to="/user/profile" />} />
            </Routes>
          </main>
        </div>
      </MyProSidebarProvider>
    </>
  );
}

export default UserLayout;